export default {
	setAbout(state, about_data) {
		state.about_data = about_data
	},
}
